module.exports = __webpack_public_path__ + "img/icon-play.d482dece.svg";